export default __webpack_public_path__ + "static/media/flag-oman.1c5e997a.svg";